// src/main.js (Vue 3)
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'              // ถ้าเป็น Vuex ให้ใช้เวอร์ชัน 4
import CoreuiVue from '@coreui/vue'
import { CIcon } from '@coreui/icons-vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import i18n from './plugins/i18n'
import '@coreui/coreui/dist/css/coreui.min.css'
import '@/assets/scss/main.scss'
import VueTelInput from 'vue3-tel-input'
import 'vue3-tel-input/dist/vue3-tel-input.css'

// (ถ้าใช้ Firebase compat)
import firebase from 'firebase/app'
import 'firebase/auth'

// ✅ สร้างแอปตามสไตล์ Vue 3
const app = createApp(App)

app.use(router)
app.use(store)         // ต้องเป็น Vuex 4 สำหรับ Vue 3
app.use(CoreuiVue)
app.use(i18n)

app.component('CIcon', CIcon)
app.provide('icons', icons)

app.config.performance = true   // Vue 3 ใช้ app.config, ไม่มี productionTip แล้ว

app.use(VueTelInput, {
  mode: 'international',        // ให้โชว์เบอร์สากล
  defaultCountry: 'TH',         // ค่าเริ่มต้นประเทศไทย (+66)
  autoFormat: true,
  validCharactersOnly: true,
})
app.mount('#app')
